const $ = window.jQuery;

const countrySelect2 = {
    init: () => {


        const eventSelect = $(".countries-select-container");
        if ($(".countries").length) {


            eventSelect.select2({
                placeholder: "Select Country",
                dropdownCssClass: "country-container"
            })
                .on('select2:open', function(e){
                    $(document.body).find('.select2-dropdown').addClass('animate-dropdown');
                }).on('select2:closing', function(e){
                    $(document.body).find('.select2-dropdown').removeClass('animate-dropdown');
            });

            eventSelect.on('select2:select', function(e) {
                var data = e.params.data;
                var url = $(data.element).data('url');
                var target = $(data.element).data('target');
                window.open(url, target);
            })

        }

    }
};
export default countrySelect2;